// Attribution text is not duplicated here: it lives in COPY.chrome.attribution
// (src/content/copy.ts) per the "all copy from COPY" constraint and is wired
// into the Leaflet tile layer by MapView.
const cartoKey = import.meta.env.VITE_CARTO_KEY;

export const CARTO_DARK_MATTER = {
  urlTemplate: `https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png${
    cartoKey ? `?key=${cartoKey}` : ""
  }`,
  subdomains: "abcd",
  maxZoom: 20,
  detectRetina: true,
} as const;
